import type { DealBookingType } from '@src/types/OTC';

export const OMSView = {
  Cards: 'CARDS_VIEW',
  ManualTradeForm: 'MANUAL_TRADE_FORM_VIEW',
  ManualDealTradeForm: 'MANUAL_DEAL_TRADE_FORM_VIEW',
  NewOrderForm: 'NEW_ORDER_FORM_VIEW',
  OrderImport: 'ORDER_IMPORT_VIEW',
  RFQForm: 'RFQ_FORM_VIEW',
  SalesRFQForm: 'SALES_RFQ_FORM_VIEW',
  SalesOrder: 'SALES_ORDER_FORM_VIEW',
  ManualOrderFillForm: 'MANUAL_ORDER_FILL_FORM_VIEW',
  ManualRFQPricingForm: 'MANUAL_RFQ_PRICING_FORM',
  DetailsDrawer: 'DETAILS_DRAWER',
  CareOrderForm: 'CARE_ORDER_FORM_VIEW',
  NotificationsInbox: 'NOTIFICATIONS_INBOX_VIEW',
} as const;
export type OMSView = (typeof OMSView)[keyof typeof OMSView];

// Type-safe view data mapping - only includes views that actually use data
export type OMSViewLaunchDataMap = {
  [K in typeof OMSView.ManualDealTradeForm]: {
    bookingType?: DealBookingType;
    templateSymbol?: string;
  };
};

// Complete mapping for all views with defaults
export type CompleteViewLaunchDataMap = {
  [K in OMSView]: K extends keyof OMSViewLaunchDataMap ? OMSViewLaunchDataMap[K] : undefined;
};

// Type-safe open view action
type OpenViewAction<T extends OMSView> = {
  view: T;
  launchData?: CompleteViewLaunchDataMap[T];
};

// Helper type for all possible open view actions
export type OMSOpenViewPayload = {
  [K in OMSView]: OpenViewAction<K>;
}[OMSView];
